import type { ComponentInternalInstance } from 'vue'
import type { IValidatorAccumulator, IValidatorAccumulatorVueComponent } from './IValidatorAccumulator'
import { ValidationStatutPoco } from './IValidatorAccumulator'
export { ValidationStatutPoco }

export class ValidatorAccumulator implements IValidatorAccumulator {
    private validationStatut: ValidationStatutPoco = new ValidationStatutPoco()

    public startValidation(nbElementsToValidate: number): boolean {
        this.validationStatut = new ValidationStatutPoco()        
        this.validationStatut.nbElementsToValidate = nbElementsToValidate
        this.validationStatut.currentElementValidated = 0
        return !this.validationIsComplete()
    }

    public validated(hasError: boolean): ValidationStatutPoco {
        this.validationStatut.currentElementValidated++
        this.validationStatut.hasError = this.validationStatut.hasError || hasError
        this.validationStatut.validationCompleted = this.validationIsComplete()

        return this.validationStatut
    }

    private validationIsComplete(): boolean {              
        return this.validationStatut.currentElementValidated >= this.validationStatut.nbElementsToValidate
    }
}

export class ValidatorAccumulatorVueComponent implements IValidatorAccumulatorVueComponent {
    constructor(private validatorAccumulator: ValidatorAccumulator) {}

    public startValidation(component: ComponentInternalInstance | null): boolean {        
        const nbElementsToValidate = this.getNbElementsToValidate(component)
        return this.validatorAccumulator.startValidation(nbElementsToValidate)
    }

    public startValidationWithAdditionalElements(component: ComponentInternalInstance | null, nbAdditionalElementsToValidate: number): boolean {
        const nbElementsToValidate = this.getNbElementsToValidate(component)
        return this.validatorAccumulator.startValidation(nbElementsToValidate + nbAdditionalElementsToValidate)
    }

    public validated(hasError: boolean): ValidationStatutPoco {
        return this.validatorAccumulator.validated(hasError)
    }

    private getNbElementsToValidate(component: ComponentInternalInstance | null): number { 
        if(!component)  
            return 0
        
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const children = (component.vnode.component!.subTree as any).dynamicChildren as []                
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const validatedChildren = children.filter((c: any) => (c.component?.vnode?.props?.onValidated)?? false)

        const nbElementsToValidate = validatedChildren.length         
        return nbElementsToValidate        
    }
}
